<template>
  <div>
    <div class="background-picture" v-on:click="onClick"
         v-bind:class="{ step1: step === 1, step2: step === 2, step3: step === 3}">
    </div>
  </div>
</template>

<script>

import { mapState } from "vuex";

export default {
  name: "IntroScreen",
  data() {
    return {
      step: 1
    };
  },
  computed: {
    ...mapState(["gameState"])
  },
  methods: {
    onClick: function() {
      this.step += 1;
      if(this.step > 3) {
        this.$store.dispatch("changeGameState", { name: "IntroScreen" });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.background-picture {
  position: absolute;
  background: #361c35;
  background-image: url('../assets/tutorial1.png');
  width: 100vw;
  height: 100vh;
  text-align: center;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
}

.step1 {
  background-image: url('../assets/tutorial1.png');
}

.step2 {
  background-image: url('../assets/tutorial2.png');
}

.step3 {
  background-image: url('../assets/tutorial3.png');
}

.credits {
  .congratulations {
    font-size: 4rem;
  }

  margin-top: 62vh;
  font-size: 3rem;
  color: white;
}


</style>
